import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { TableContext } from "../../index";
import * as urlService from "../../view/urlService";


export const useBaselineTableHelper = () => {

    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);

    const hardReload = (props = {}) => {
        setConfig({
            ...config,
            selected: [],
            selectAll: false,
            hardReload: true,
            lastUpdated: Date.now(),
            ...props
        });
    }

    const onHostClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('hostName')
        })
    }

    const onCompliantClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('pciCompliance')
        })
    }

    const onStatusClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('status')
        })
    }

    const changeGroupFilter = (value) => {

        if (Number(value) < 0) {
            history.push({
                pathname: history.pathname,
                search: urlService.removeFilter('groupId')
            })
            return;
        }

        history.push({
            pathname: history.pathname,
            search: urlService.replaceFilters('groupId', value)
        })
    }

    const changeDeviceFilter = (value) => {

        if (Number(value) === -1) {
            history.push({
                pathname: history.pathname,
                search: urlService.removeFilter('device')
            })
            return;
        }

        history.push({
            pathname: history.pathname,
            search: urlService.updateFilters('device', value)
        })
    }

    const updatePagination = (page, size) => {
        history.push(
            {
                pathname: history.pathname,
                search: urlService.updatePagination(page, size)
            }
        )
    }

    return {
        hardReload,
        onHostClick,
        onCompliantClick,
        onStatusClick,
        changeGroupFilter,
        updatePagination,
        changeDeviceFilter
    }
}
